import React, { useContext } from "react"
import { Tooltip } from "antd"
import { User } from "react-feather"
import { AuthContext } from "../../contexts/auth/AuthContext"
import i18n from "../../services/i18n"

// ============================================================================
// KIM KIRGAN (egasi 2026-09-02, prioritet 1): sarlavhada ism · rol · tizim.
// Tor ekranda faqat belgi; ustiga kelinsa to'liq ma'lumot (email, rol, tizim, ID).
// ============================================================================
const ROLE_LABEL: Record<string, string> = {
  "super-admin": "Главный администратор",
  manager: "Менеджер",
  counterparty: "Контрагент",
  counterpartycabinet: "Контрагент (кабинет)",
  shop: "Магазин",
  shopsystem: "Магазин (система)",
  dataadmin: "Администратор данных",
  factory: "Завод",
}

export default function UserChip() {
  const { authState } = useContext(AuthContext)
  const u: any = authState?.user
  if (!u) return null
  const roleCode: string = (u?.mainRoles?.resourceName || u?.roleName || (u?.role === 1 || u?.roleId === 1 ? "super-admin" : "") || "").toString()
  const roleLabel = ROLE_LABEL[roleCode.toLowerCase()] || roleCode || "—"
  const tenantId = Number(u?.tenantId || 1)
  const system = tenantId <= 1
    ? "GLAVNIY (SAV)"
    : (u?.tenantType === "shop_owner" ? i18n.t("shop") : i18n.t("counterparty")) + " №" + tenantId + (u?.parentName ? " · " + i18n.t("supplier") + ": " + u.parentName : "")
  // userName bazada odam ismi emas, tur yorlig'i ("Manager"/"Administrator") — asosiy qator EMAIL (kim kirganini aniq bildiradi)
  const name = u?.email || u?.userName || "—"
  const alias = u?.userName && u?.email ? u.userName : null
  const tip = (
    <div style={{ lineHeight: 1.6 }}>
      <div><b>{name}</b></div>
      {alias && <div>{alias}</div>}
      <div>{i18n.t("role")}: {roleLabel}</div>
      <div>{i18n.t("system")}: {system}</div>
      <div style={{ opacity: 0.75 }}>ID {u?.id ?? u?.userId ?? "—"}{u?.managerId ? " · manager " + u.managerId : ""}{u?.counterpartyId ? " · ct " + u.counterpartyId : ""}</div>
    </div>
  )
  return (
    <Tooltip placement="bottom" title={tip}>
      <div className="user-chip headermargin_r">
        <span className="user-chip-icon"><User size={18} strokeWidth={2} /></span>
        <span className="user-chip-text">
          <span className="user-chip-name">{name}</span>
          <span className="user-chip-role">{roleLabel}{tenantId > 1 ? " · №" + tenantId : ""}</span>
        </span>
      </div>
    </Tooltip>
  )
}
